import {
  AcceptableAgeType,
  AvailabilityType,
  ContractType,
  DisabilityLevel,
  DisabilityType,
  MealAssistanceType,
  MealServiceType,
  MedicalCareType,
  ParentSeparationType,
  PopularFeatureType,
  ReviewStatus,
  StaffType,
  SupportCategory,
  SupportContentType,
  InquiryType,
  InquiryStatus,
  Occupation,
  OccupationCategory,
} from "@/types";

export const DISABILITY_TYPE_LABEL = [
  { label: "肢体不自由 (身体障害)", value: DisabilityType.MOBILITY_IMPAIRMENT },
  { label: "聴覚障害 (身体障害)", value: DisabilityType.HEARING_IMPAIRMENT },
  { label: "視覚障害 (身体障害)", value: DisabilityType.VISUAL_IMPAIRMENT },
  { label: "発達障害", value: DisabilityType.DEVELOPMENTAL_DISABILITY },
  { label: "知的障害", value: DisabilityType.INTELLECTUAL_DISABILITY },
  { label: "重症心身障害", value: DisabilityType.SEVERE_MULTIPLE_DISABILITIES },
];

export const DISABILITY_LEVEL_LABEL = [
  { label: "軽度", value: DisabilityLevel.MILD },
  { label: "中度", value: DisabilityLevel.MODERATE },
  { label: "重度", value: DisabilityLevel.SEVERE },
  { label: "最重度", value: DisabilityLevel.MOST_SEVERE },
];

// 支援種別
export const SUPPORT_CATEGORY_LABEL = [
  {
    label: "児童発達支援センター・事業所",
    value: SupportCategory.CHILD_DEVELOPMENT_CENTER,
  },
  {
    label: "放課後等デイサービス",
    value: SupportCategory.AFTER_SCHOOL_DAY_SERVICE,
  },
  {
    label: "訪問看護",
    value: SupportCategory.HOME_NURSING,
  },
  {
    label: "訪問介護",
    value: SupportCategory.HOME_CARE,
  },
  {
    label: "短期入所施設",
    value: SupportCategory.SHORT_STAY,
  },
  {
    label: "相談支援事業所",
    value: SupportCategory.CONSULTATION_SUPPORT,
  },
  {
    label: "保育園",
    value: SupportCategory.NURSERY,
  },
  {
    label: "訪問診療",
    value: SupportCategory.HOME_MEDICAL_VISIT,
  },
  {
    label: "訪問調剤",
    value: SupportCategory.HOME_PHARMACY_SERVICE,
  },
  {
    label: "保育所等訪問支援",
    value: SupportCategory.NURSERY_VISIT_SUPPORT,
  },
  {
    label: "居宅児童発達支援",
    value: SupportCategory.HOME_DEVELOPMENT_SUPPORT,
  },
  {
    label: "子ども預かり",
    value: SupportCategory.CHILD_CARE_SERVICE,
  },
  {
    label: "その他支援",
    value: SupportCategory.OTHER_SUPPORT,
  },
];

export const SUPPORT_CONTENT_LABEL = [
  {
    label: "宿泊型短期入所",
    value: SupportContentType.OVERNIGHT_SHORT_STAY,
  },
  {
    label: "移動支援",
    value: SupportContentType.TRANSPORT_SUPPORT,
  },
  {
    label: "居宅訪問介護",
    value: SupportContentType.HOME_VISIT_CARE,
  },
  {
    label: "日中一時",
    value: SupportContentType.DAYTIME_TEMPORARY_CARE,
  },
  {
    label: "在宅レスパイト",
    value: SupportContentType.HOME_RESPITE,
  },
  {
    label: "個別支援",
    value: SupportContentType.INDIVIDUAL_SUPPORT,
  },
  {
    label: "集団支援",
    value: SupportContentType.GROUP_SUPPORT,
  },
  {
    label: "24時間緊急対応あり",
    value: SupportContentType.EMERGENCY_24H_SUPPORT,
  },
  {
    label: "日帰りショートステイ",
    value: SupportContentType.DAY_SHORT_STAY,
  },
];

export const POPULAR_FEATURE_LABEL = [
  {
    label: "土日祝日対応あり",
    value: PopularFeatureType.WEEKEND_SUPPORT,
  },
  {
    label: "送迎あり",
    value: PopularFeatureType.TRANSPORTATION,
  },
  {
    label: "入浴支援あり",
    value: PopularFeatureType.BATH_SUPPORT,
  },
  {
    label: "給食あり",
    value: PopularFeatureType.MEAL_PROVISION,
  },
  {
    label: "看護師常勤",
    value: PopularFeatureType.FULL_TIME_NURSE,
  },
  {
    label: "リハビリ_PT 実施可能",
    value: PopularFeatureType.REHABILITATION_PT,
  },
  {
    label: "リハビリ_ST 実施可能",
    value: PopularFeatureType.REHABILITATION_ST,
  },
  {
    label: "リハビリ_OT 実施可能",
    value: PopularFeatureType.REHABILITATION_OT,
  },
];

export const FACILITY_STAFF_LABEL = [
  {
    label: "保育士",
    value: StaffType.NURSERY_TEACHER,
  },
  {
    label: "幼稚園教諭",
    value: StaffType.KINDERGARTEN_TEACHER,
  },
  {
    label: "社会福祉士",
    value: StaffType.SOCIAL_WORKER,
  },
  {
    label: "医師",
    value: StaffType.DOCTOR,
  },
  {
    label: "看護師",
    value: StaffType.NURSE,
  },
  {
    label: "保健師",
    value: StaffType.PUBLIC_HEALTH_NURSE,
  },
  {
    label: "児童指導員",
    value: StaffType.CHILD_GUIDANCE_STAFF,
  },
  {
    label: "理学療法士（PT）",
    value: StaffType.PHYSICAL_THERAPIST,
  },
  {
    label: "言語聴覚士（ST）",
    value: StaffType.SPEECH_THERAPIST,
  },
  {
    label: "作業療法士（OT）",
    value: StaffType.OCCUPATIONAL_THERAPIST,
  },
  {
    label: "医療的ケア児コーディネーター",
    value: StaffType.MEDICAL_CARE_CHILD_COORDINATOR,
  },
  {
    label: "介護福祉士",
    value: StaffType.CARE_WORKER,
  },
  {
    label: "臨床心理士",
    value: StaffType.CLINICAL_PSYCHOLOGIST,
  },
  {
    label: "相談支援専門員",
    value: StaffType.CONSULTATION_SUPPORT_SPECIALIST,
  },
];

/** 職種カテゴリのラベル (表示順) */
export const OCCUPATION_CATEGORY_LABEL: {
  label: string;
  value: OccupationCategory;
}[] = [
  { label: "管理・運営職", value: OccupationCategory.MGMT },
  { label: "配置基準上の責任者職", value: OccupationCategory.RESP },
  { label: "直接支援・介護職", value: OccupationCategory.CARE },
  { label: "児童・保育職", value: OccupationCategory.CHILD },
  { label: "医療・看護職", value: OccupationCategory.MED },
  { label: "リハビリ・心理・栄養職", value: OccupationCategory.REHAB },
  { label: "その他", value: OccupationCategory.OTHER },
];

/** 職種マスター (31種・宣言順 = 表示順)。各要素にカテゴリを保持しグルーピング表示に使う */
export const OCCUPATION_LABEL: {
  label: string;
  value: Occupation;
  category: OccupationCategory;
}[] = [
  // 管理・運営職
  { label: "代表・経営者", value: Occupation.EXECUTIVE, category: OccupationCategory.MGMT },
  { label: "施設長", value: Occupation.FACILITY_HEAD, category: OccupationCategory.MGMT },
  { label: "管理者", value: Occupation.MANAGER, category: OccupationCategory.MGMT },
  { label: "事務職員", value: Occupation.CLERICAL_STAFF, category: OccupationCategory.MGMT },
  // 配置基準上の責任者職
  { label: "サービス管理責任者(サビ管)", value: Occupation.SERVICE_MANAGER, category: OccupationCategory.RESP },
  { label: "児童発達支援管理責任者(児発管)", value: Occupation.CHILD_DEVELOPMENT_MANAGER, category: OccupationCategory.RESP },
  { label: "相談支援専門員", value: Occupation.CONSULTATION_SUPPORT_SPECIALIST, category: OccupationCategory.RESP },
  { label: "介護支援専門員(ケアマネ)", value: Occupation.CARE_MANAGER, category: OccupationCategory.RESP },
  { label: "サービス提供責任者(サ責)", value: Occupation.SERVICE_PROVIDER_RESPONSIBLE, category: OccupationCategory.RESP },
  { label: "計画作成担当者", value: Occupation.CARE_PLAN_CREATOR, category: OccupationCategory.RESP },
  { label: "社会福祉士・精神保健福祉士", value: Occupation.SOCIAL_WORKER, category: OccupationCategory.RESP },
  // 直接支援・介護職
  { label: "介護福祉士", value: Occupation.CERTIFIED_CARE_WORKER, category: OccupationCategory.CARE },
  { label: "介護職員(無資格・初任者・実務者)", value: Occupation.CARE_WORKER, category: OccupationCategory.CARE },
  { label: "生活支援員", value: Occupation.LIFE_SUPPORT_WORKER, category: OccupationCategory.CARE },
  { label: "世話人", value: Occupation.CARETAKER, category: OccupationCategory.CARE },
  { label: "職業指導員", value: Occupation.VOCATIONAL_INSTRUCTOR, category: OccupationCategory.CARE },
  { label: "就労支援員", value: Occupation.EMPLOYMENT_SUPPORT_WORKER, category: OccupationCategory.CARE },
  { label: "夜間支援従事者", value: Occupation.NIGHT_SUPPORT_WORKER, category: OccupationCategory.CARE },
  // 児童・保育職
  { label: "保育士", value: Occupation.NURSERY_TEACHER, category: OccupationCategory.CHILD },
  { label: "児童指導員", value: Occupation.CHILD_GUIDANCE_STAFF, category: OccupationCategory.CHILD },
  { label: "保育補助・保育支援員", value: Occupation.NURSERY_ASSISTANT, category: OccupationCategory.CHILD },
  // 医療・看護職
  { label: "医師", value: Occupation.DOCTOR, category: OccupationCategory.MED },
  { label: "看護職員(看護師・准看護師・保健師)", value: Occupation.NURSE, category: OccupationCategory.MED },
  { label: "薬剤師", value: Occupation.PHARMACIST, category: OccupationCategory.MED },
  // リハビリ・心理・栄養職
  { label: "理学療法士(PT)", value: Occupation.PHYSICAL_THERAPIST, category: OccupationCategory.REHAB },
  { label: "作業療法士(OT)", value: Occupation.OCCUPATIONAL_THERAPIST, category: OccupationCategory.REHAB },
  { label: "言語聴覚士(ST)", value: Occupation.SPEECH_THERAPIST, category: OccupationCategory.REHAB },
  { label: "心理担当職員(公認心理師・臨床心理士)", value: Occupation.PSYCHOLOGY_STAFF, category: OccupationCategory.REHAB },
  { label: "管理栄養士・栄養士", value: Occupation.DIETITIAN, category: OccupationCategory.REHAB },
  { label: "調理員", value: Occupation.COOK, category: OccupationCategory.REHAB },
  // その他
  { label: "その他", value: Occupation.OTHER, category: OccupationCategory.OTHER },
];

/** 値 → 職種ラベルの逆引きマップ (表示用) */
export const OCCUPATION_LABEL_MAP: Record<number, string> = Object.fromEntries(
  OCCUPATION_LABEL.map((o) => [o.value, o.label]),
);

/** カテゴリごとに職種をまとめた optgroup 描画用の構造 (表示順) */
export const OCCUPATION_GROUPS: {
  category: OccupationCategory;
  label: string;
  options: { label: string; value: Occupation }[];
}[] = OCCUPATION_CATEGORY_LABEL.map((cat) => ({
  category: cat.value,
  label: cat.label,
  options: OCCUPATION_LABEL.filter((o) => o.category === cat.value).map(
    ({ label, value }) => ({ label, value }),
  ),
}));

/** 職種値の配列をラベル配列に変換する (未知値は除外) */
export const occupationLabels = (values?: number[] | null): string[] =>
  (values ?? [])
    .map((v) => OCCUPATION_LABEL_MAP[v])
    .filter((label): label is string => Boolean(label));

export const MEDICAL_CARE_LABEL = [
  {
    label: "経管栄養（胃管・腸管・胃ろう）",
    value: MedicalCareType.ENTERAL_FEEDING,
  },
  {
    label: "人工呼吸器",
    value: MedicalCareType.MECHANICAL_VENTILATION,
  },
  {
    label: "酸素投与",
    value: MedicalCareType.OXYGEN_THERAPY,
  },
  {
    label: "吸引",
    value: MedicalCareType.SUCTION,
  },
  {
    label: "ネブライザー（吸入）",
    value: MedicalCareType.NEBULIZER,
  },
  {
    label: "皮下注射",
    value: MedicalCareType.SUBCUTANEOUS_INJECTION,
  },
  {
    label: "中心静脈カテーテルの管理",
    value: MedicalCareType.CENTRAL_VENOUS_CATHETER,
  },
  {
    label: "排便管理（ストーマ）",
    value: MedicalCareType.STOOL_MANAGEMENT,
  },
  {
    label: "導尿",
    value: MedicalCareType.CATHETERIZATION,
  },
  {
    label: "気管切開の管理",
    value: MedicalCareType.TRACHEOSTOMY_MANAGEMENT,
  },
];

// 親子分離
export const PARENT_SEPARATION_LABEL = [
  {
    label: "親子分離可",
    value: ParentSeparationType.SEPARATION_ALLOWED,
  },
  {
    label: "親子利用",
    value: ParentSeparationType.PARENT_CHILD_USE,
  },
  {
    label: "条件付き親子分離可",
    value: ParentSeparationType.CONDITIONAL_SEPARATION,
  },
];

export const MEAL_ASSISTANCE_LABEL = [
  {
    label: "食事介助可能",
    value: MealAssistanceType.AVAILABLE,
  },
];

export const MEAL_SERVICE_LABEL = [
  {
    label: "普通食提供可能",
    value: MealServiceType.REGULAR_MEAL,
  },
  {
    label: "きざみ食提供可能",
    value: MealServiceType.MINCED_MEAL,
  },
  {
    label: "ペースト食提供可能",
    value: MealServiceType.PASTE_MEAL,
  },
  {
    label: "食事持参",
    value: MealServiceType.BRING_YOUR_MEAL,
  },
  {
    label: "食事提供なし",
    value: MealServiceType.NO_MEAL_PROVIDED,
  },
];

export const ACCEPTABLE_AGE_LABEL = [
  {
    label: "乳児（0〜2歳）",
    value: AcceptableAgeType.INFANT,
  },
  {
    label: "幼児（3〜6歳）",
    value: AcceptableAgeType.TODDLER,
  },
  {
    label: "小学校低学年（6歳〜9歳）",
    value: AcceptableAgeType.ELEMENTARY_LOWER,
  },
  {
    label: "小学校高学年（9歳〜12歳）",
    value: AcceptableAgeType.ELEMENTARY_UPPER,
  },
  {
    label: "中学生",
    value: AcceptableAgeType.MIDDLE_SCHOOL,
  },
  {
    label: "高校生",
    value: AcceptableAgeType.HIGH_SCHOOL,
  },
];

export const INQUIRY_LABEL = [
  {
    label: "見学希望",
    value: InquiryType.TOUR_REQUEST,
  },
  {
    label: "空き状況",
    value: InquiryType.AVAILABILITY_INQUIRY,
  },
  {
    label: "支援内容",
    value: InquiryType.SUPPORT_CONTENT_INQUIRY,
  },
  {
    label: "その他",
    value: InquiryType.OTHER,
  },
];

export const AVAILABILITY_TYPE_LABEL = [
  {
    label: "空きあり",
    value: AvailabilityType.AVAILABLE,
  },
  {
    label: "やや空きあり",
    value: AvailabilityType.LIMITED_AVAILABILITY,
  },
  {
    label: "満員",
    value: AvailabilityType.FULL,
  },
];

export const CONTRACT_TYPE_LABEL = [
  {
    label: "ライト",
    value: ContractType.LIGHT,
  },
  {
    label: "スタンダード",
    value: ContractType.STANDARD,
  },
  {
    label: "プレミアム",
    value: ContractType.PREMIUM,
  },
];

export const REVIEW_STATUS_LABEL = [
  { label: "確認待ち", value: ReviewStatus.PENDING },
  { label: "掲載中", value: ReviewStatus.PUBLISHED },
  { label: "非公開", value: ReviewStatus.UNPUBLISHED },
];

export const INQUIRY_STATUS_LABEL = [
  { label: "未確認", value: InquiryStatus.UNCONFIRMED },
  { label: "対応待ち", value: InquiryStatus.WAITING },
  { label: "対応済み", value: InquiryStatus.COMPLETED },
  { label: "保留", value: InquiryStatus.PENDING },
];

export const INQUIRY_TYPE_LABEL = [
  { label: "見学希望", value: InquiryType.TOUR_REQUEST },
  { label: "空き状況", value: InquiryType.AVAILABILITY_INQUIRY },
  { label: "支援内容", value: InquiryType.SUPPORT_CONTENT_INQUIRY },
  { label: "その他", value: InquiryType.OTHER },
];
